import store from '../store'
function topMenuLink() {
  let linkProp = { link: null, key: null }
  switch (store.state.route.path) {
    case '/':
    case '/profile':
      linkProp =
        store.state.userInfo && localStorage.getItem('userInfo')
          ? { link: '/logout', key: 'k_logout_title' }
          : { link: null, key: null }
      break
    case '/coupon':
    case '/coupon-active':
      linkProp = { link: '/profile', key: 'k_myaccount_title' }
      break
    case '/payment':
    case '/payment-success':
      linkProp = { link: '/profile', key: 'k_myaccount_title' }
      break
    case '/reset-password-done':
      linkProp = { link: '/profile', key: 'k_myaccount_title' }
      break
    case '/forgot':
      break
    case '/cancel-plan':
      linkProp = { link: '/profile', key: 'k_myaccount_title' }
      break
    case '/change-password':
      linkProp = { link: '/profile', key: 'k_myaccount_title' }
      break
  }
  return linkProp
}

export { topMenuLink }
